module.exports = __webpack_public_path__ + "img/4.96b56cd1.png";